const departments = [
  { name: 'Sales' },
  { name: 'Marketing' },
  { name: 'Engineering' },
  { name: 'Human Ressources' },
  { name: 'Legal' },
]

export { departments }
